import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const ratingValue = this.element.querySelector('.rating-value');
        const input = this.element.querySelector('.input');
        ratingValue.addEventListener('click', function (e) {
            let value = parseInt(e.target.dataset.value);
            if (value) {
                value += (e.layerX > (e.target.clientWidth / 2) ? 1 : 0);
                input.value = value;
                // eslint-disable-next-line require-unicode-regexp
                ratingValue.className = ratingValue.className.replace(/value-([^ ]*)/g, '');
                ratingValue.classList.add(`value-${value}`);
            }
        });
    }
}
